// extracted by mini-css-extract-plugin
export var errorIcon = "_l1-1";
export var nameLogo = "_l1-0";